<script>
export default {
	props: {},
	data() {
		return {};
	},
	methods: {
		print() {
			window.print();
		},
	},
};
</script>

<template>
	<button
		class="sky-print"
		@click.prevent="print">
		<slot />
	</button>
</template>
<style src="./sky-print.scss"></style>



// WEBPACK FOOTER //
// sky-print.vue?e1f57784